// Returns true when values are the same
export function deepCompare(valueA, valueB) {
  if (Array.isArray(valueA) && Array.isArray(valueB)) {
    return !valueA.find((ele, index) => ele !== valueB[index])
  } else if (valueA !== null && valueB !== null && typeof valueA === 'object' && typeof valueB === 'object') {
    if (!deepCompare(Object.keys(valueA).sort(), Object.keys(valueB).sort())) return false
    return !Object.keys(valueA).find(key => valueA[key] !== valueB[key])
  } else {
    return valueA === valueB
  }
}
